import React, { } from 'react';
import ActiveForm from './partials/ActiveForm';
import ValidatedForm from './partials/ValidatedForm';
import UnfilledForm from './partials/UnfilledForm';
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';


const CardetailsForm = props => {

    const { formValues, view } = props;
    const content = {
        heading: 'Biluppgifter',
        desc: ''
    }

    switch (view) {
        case 'active':
            const form = (
                <Formik
                    initialValues={{ regnr: formValues.regnr, mileage: formValues.mileage }}
                    validationSchema={Yup.object({
                        regnr: Yup.string()
                            // .min(5, 'Innehåller för få tecken')
                            .matches(/^[A-Za-z]{3}[0-9]{2}[A-Za-z0-9]{1}$/, 'Registreringsnumret har fel format')
                            .required('Måste fyllas i'),
                        mileage: Yup.number()
                            .required('Måste fyllas i')
                            .max(99999, 'Miltalet får inte överstigga 99 999')
                    })}
                    onSubmit={(values, { setSubmitting }) => {
                        values.regnr = values.regnr.toUpperCase();
                        setTimeout(() => {
                            setSubmitting(false);
                            props.handleSteps(1, values, 2);
                        }, 200);
                    }}
                >
                    {({ isValid }) => (
                        <Form>
                            <div className="form-fields cardetails">
                                <div className="input-regnr">
                                    <label htmlFor="regnr">Registreringsnummer</label>
                                    <Field name="regnr" type="text" />
                                    <div className="form-error-msg">
                                        <ErrorMessage name="regnr" />
                                    </div>
                                </div>

                                <div className="input-mileage">
                                    <label htmlFor="mileage">Miltal</label>
                                    <Field name="mileage" type="number" />
                                    <div className="form-error-msg">
                                        <ErrorMessage name="mileage" />
                                    </div>
                                </div>
                            </div>

                            <div className="form-button-container">
                                <button className="form-button-wide" type="submit" disabled={!isValid}>Gå vidare</button>
                            </div>
                        </Form>
                    )}
                </Formik>
            );
            return (<ActiveForm content={content} form={form} step={1} />)
        case 'unfilled': return (<UnfilledForm content={content} step={1} />)
        case 'validated': return (<ValidatedForm content={content} step={1} values={[formValues?.regnr, formValues?.mileage?.toLocaleString() + ' mil']} setStep={props.setStep} />)
        default: return (<div>Default</div>)
    }


}



export default CardetailsForm
